import {JSONSchema7} from "json-schema";
import {makeCssSchemaDefinitions} from "./css-schema";
import {makeAssignVariable} from "./rule-engine/assign-variable";
import {JEXL_WIKI_MARKDOWN, makeJexlExpression} from "./rule-engine/jexl-expressions";
import {makeRuleThenPropMapping} from "./rule-engine/prop-mapping";
import {makeSidebarSchema, makeTabSchema} from "./ui-schema";

export const makeUiConfigSchema = (possibleStateRefs: string[], possibleQueryableRefs: string[], possiblePages: string[]): string => {
  const routeSchema: JSONSchema7 = {type: "string", minLength: 1, pattern: "^/[a-z]+"};

  const uiConfig: JSONSchema7 = {
    type: "object",
    additionalProperties: false,
    required: ["route"],
    properties: {
      route: routeSchema,
      routeParams: {type: "array", items: {type: "string"}},
      type: {
        type: "string",
        enum: ["standard", "dialog", "drawer"],
        default: "standard"
      },
      title: {type: "string"},
      'title:expr': makeJexlExpression(`Define page title via ${JEXL_WIKI_MARKDOWN}`),
      mainPage: {type: "string", enum: possiblePages},
      sidebar: makeSidebarSchema(possibleQueryableRefs),
      tab: makeTabSchema(),
      props: {
        type: "object",
        additionalProperties: true,
        properties: {
          container: {$ref: "#/definitions/mui-container"}
        }
      },
      'props:expr': {$ref: "#/definitions/rule_then_prop_mapping"},
      breadcrumb: {
        oneOf: [
          {type: "string", minLength: 1},
          {
            type: "object",
            additionalProperties: false,
            required: ["data", "label"],
            properties: {
              data: {type: "string", enum: possibleStateRefs},
              label: {
                oneOf: [
                  {type: "string", minLength: 1},
                  {$ref: "#/definitions/rule_then_assign_variable"}
                ]
              }
            }
          }
        ]
      }
    },
    definitions: {
      ...makeAssignVariable('value'),
      ...makeRuleThenPropMapping(),
      ...makeCssSchemaDefinitions()
    }
  }

  return JSON.stringify(uiConfig);
}
